<template>
  <div class="nuttrema-layout-page-content" :class="[theme ? `theme-${theme}` : '']">
    <div class="nuttrema-layout-page-content__theme"><i class="far"></i></div>
    <div class="nuttrema-layout-page-content__top" v-if="$slots['title'] || $slots['sub-title']">
      <div class="top__title" v-if="$slots['title']">
        <slot name="title"></slot>
      </div>
      <div class="top__sub-title" v-if="$slots['sub-title']">
        <slot name="sub-title"></slot>
      </div>
    </div>

    <div class="nuttrema-layout-page-content__middle">
      <slot></slot>
    </div>

    <div class="nuttrema-layout-page-content__bottom" v-if="$slots['footer']">
      <div class="bottom__footer">
        <slot name="footer"></slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'nuttrema-layout-page-content',
  props: {
    theme: {
      type: String,
      required: false,
      default: null,
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~styles/theme/colors';
@import '~styles/mixins/gradients';

.nuttrema-layout-page-content {
  flex-grow: 1;
  display: flex;
  position: relative;
  align-self: stretch;
  flex-direction: column;
  justify-content: space-between;

  max-width: 1600px;

  overflow-y: auto;
  padding: 0;

  .nuttrema-layout-page-content__top {
    z-index: 1;
    position: relative;
    display: flex;
    flex-shrink: 0;
    align-items: center;
    flex-direction: column;
    justify-content: center;

    padding: 2em 0;

    .top__title {
      color: #fff;
      font-size: 2.5em;
      font-weight: 200;
    }

    .top__sub-title {
      color: #fff;
      font-size: 1.15em;
    }
  }

  .nuttrema-layout-page-content__middle {
    z-index: 1;
    position: relative;
    flex-grow: 1;
    display: flex;
    flex-shrink: 0;
    flex-direction: column;
    padding: 0 2em 0 2.5em;
  }

  .nuttrema-layout-page-content__bottom {
    z-index: 1;
    position: relative;
    display: flex;
    flex-shrink: 0;
    justify-content: center;
    align-items: center;

    padding: 0;

    .bottom__footer {
      color: #fff;
      flex-grow: 1;
      display: flex;
      text-align: center;
    }
  }

  .nuttrema-layout-page-content__theme {
    top: 0;
    left: 0;
    bottom: 0;
    z-index: 0;
    right: 20px;
    content: '';
    position: fixed;
  }

  // themes
  &.theme-dc-logo {
    .nuttrema-layout-page-content__theme {
      opacity: 0.75;
      background-size: 48em;
      background-repeat: no-repeat;
      background-position: right -6em bottom -2em;
      background-image: url('~assets/images/dc-logo-bg.svg');
      > i {
        display: none;
      }
    }
  }

  &.is-dc-logo {
    .nuttrema-layout-page-content__theme {
      opacity: 0.15;
      background-size: 48em;
      background-repeat: no-repeat;
      background-position: right -6em bottom -2em;
      background-image: url('~assets/images/dc-logo-bg-gray.svg');
      > i {
        display: none;
      }
    }
  }

  &.is-register {
    .nuttrema-layout-page-content__theme {
      > i {
        color: #fff;
        right: -1rem;
        bottom: -5rem;
        opacity: 0.05;
        font-size: 30em;
        position: fixed;
        &:before {
          content: '\F2B5';
        }
      }
    }
  }

  &.is-login {
    .nuttrema-layout-page-content__theme {
      > i {
        color: #fff;
        right: -1rem;
        bottom: -4rem;
        opacity: 0.05;
        font-size: 30em;
        position: fixed;
        &:before {
          content: '\f084';
        }
      }
    }
  }

  &.is-forgot {
    .nuttrema-layout-page-content__theme {
      > i {
        color: #fff;
        right: -1rem;
        bottom: 0rem;
        opacity: 0.05;
        font-size: 30em;
        position: fixed;
        &:before {
          content: '\f0eb';
        }
      }
    }
  }

  &.theme-thank-you {
    .nuttrema-layout-page-content__theme {
      > i {
        color: #fff;
        right: -5rem;
        bottom: -5rem;
        opacity: 0.05;
        font-size: 34em;
        position: fixed;
        &:before {
          content: '\f336';
        }
      }
    }
  }

  &.theme-join-instance {
    .nuttrema-layout-page-content__theme {
      > i {
        color: #fff;
        right: -1rem;
        bottom: -5rem;
        opacity: 0.05;
        font-size: 30em;
        font-weight: 100;
        position: fixed;
        &:before {
          content: '\f0c0';
        }
      }
    }
  }
  // themes

  &.is-turquoise {
    @include gradient-horizontal($turquoise, darken($turquoise, 5%));
  }

  &.theme-turquoise,
  .nuttrema-theme-professional-turquoise & {
    @include gradient-horizontal($turquoise, darken($turquoise, 5%));
  }

  &.theme-topography,
  .nuttrema-theme-professional-topography & {
    .nuttrema-layout-page-content__bottom {
      .bottom__footer {
        color: #475669;
      }
    }
    .nuttrema-layout-page-content__theme {
      > i {
        color: #475669;
      }
    }
  } // end ~ theme-topography
}
</style>



// WEBPACK FOOTER //
// src/components/ui/layout/nuttrema-layout-page-content.vue